// Geolocation service for detecting user's country
// Uses ipgeolocation.io with API key from .env for direct frontend requests

const API_KEY = import.meta.env.VITE_GEOLOCATION_API_KEY;

export const detectUserCountry = async () => {
  try {
    const response = await fetch(`https://api.ipgeolocation.io/ipgeo?apiKey=${API_KEY}`);
    if (response.ok) {
      const data = await response.json();
      return {
        country: data.country_name,
        countryCode: data.country_code2,
        isTunisia: data.country_name && data.country_name.toLowerCase() === 'tunisia'
      };
    }
    throw new Error('Failed to fetch location');
  } catch (error) {
    return {
      country: 'Unknown',
      countryCode: 'UN',
      isTunisia: false
    };
  }
};

// Cache the geolocation result to avoid repeated API calls
let cachedGeolocation = null;
let cacheTimestamp = null;
const CACHE_DURATION = 30 * 60 * 1000; // 30 minutes

export const getCachedUserCountry = async () => {
  const now = Date.now();
  if (cachedGeolocation && cacheTimestamp && (now - cacheTimestamp) < CACHE_DURATION) {
    return cachedGeolocation;
  }
  const geolocation = await detectUserCountry();
  cachedGeolocation = geolocation;
  cacheTimestamp = now;
  return geolocation;
};

export const isUserInTunisia = async () => {
  const geolocation = await getCachedUserCountry();
  return geolocation.isTunisia;
};

export const getUserCountryInfo = async () => {
  return await getCachedUserCountry();
}; 